import React, {Component} from 'react';
import axios from "axios";
import Breadcrumb from "../../../components/Layout/Breadcrumb";
import {RiBankFill} from "react-icons/ri";
import {Alert, Card, CardBody, CardFooter, Col, Row} from "reactstrap";
import {Nav, Spinner, Tab} from "react-bootstrap";
import { connect } from 'react-redux';
import AutoBankingComponent from "../../../components/Admin/config_systems/AutoBankingComponent";

class AutoBanking extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isLoading: true,
            disableButtonSave: false,
            listAutoBanking: [],
            error: false,
            successForm: false,
            messageError: '',
            list_config_payment: [],
            isNotification: false,
            textNotification: '',
            keyTab: 0,
            btnSubmit: false,
        }
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        this.getConfigSystem();
        this.setState({
            isNotification: this.props.isNotification,
            textNotification: this.props.textNotification,
        })
        if ( this.props.isNotification ) {
            this.props.notification({
                isNotification: false,
                textNotification: ''
            });
        }
    }

    getConfigSystem = () => {
        this.setState({
            isLoading: true
        });

        let dataAuth = {
            username: process.env.REACT_APP_CLIENT_ID,
            password: process.env.REACT_APP_CLIENT_PASSWD,
            token: process.env.REACT_APP_KEY,
        };

        let config = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization' : this.props.token,
                'dataAgency' : JSON.stringify(dataAuth)
            }
        }

        axios.get( process.env.REACT_APP_API_URL + '/api/admin/get-auto-banking', config)
            .then( (ref) => {
                // console.log(ref.data);
                if ( ref.data.error === 0 ) {
                    this.setState({
                        isLoading: false,
                        listAutoBanking: ref.data.listAutoBanking,
                        list_config_payment: ref.data.list_config_payment,
                        error: false,
                        messageError: '',
                    })
                } else {
                    if ( ref.data.error === 9999 || ref.data.error === 9998 || ref.data.error === 9997 ) {
                        this.props.logOut();
                    } else {
                        this.setState({
                            error: true,
                            messageError: ref.data.message,
                            isLoading: false
                        })
                    }
                }
            })
            .catch( (error) => {
                console.log(error);
                this.setState({
                    error: true,
                    messageError: 'Lấy dữ liệu thất bại',
                    isLoading: false
                })
            })
    }

    checkNotification = () => {
        if ( this.state.isNotification ) {
            return (
                <Alert color="success">{ this.state.textNotification } </Alert>
            );
        }
    }

    loadAutoBanking = () => {
        if (this.state.listAutoBanking.length) {
            return (
                <div className="row" id="config-system">
                    <div className="col-12">
                        <Tab.Container defaultActiveKey={"autoBanking" + this.state.keyTab}>
                            <Row>
                                <Col sm={12} className="pb-3 mb-3"
                                     style={{ borderBottom: 'solid #dbdada 1px' }}
                                >
                                    <Nav variant="pills">
                                        {
                                            this.state.listAutoBanking.map( (autoBanking, key) => (
                                                <Nav.Item>
                                                    <Nav.Link eventKey={"autoBanking" + key} key={key} className="nav-pills-sm">
                                                        { autoBanking.type }
                                                    </Nav.Link>
                                                </Nav.Item>
                                            ))
                                        }
                                    </Nav>
                                </Col>
                                <Col sm={12}>
                                    <Tab.Content>
                                        {
                                            this.state.listAutoBanking.map( (autoBanking, key) => (
                                                <Tab.Pane eventKey={"autoBanking" + key} key={key}>
                                                    <AutoBankingComponent
                                                        actionKey={key}
                                                        autoBaking={autoBanking}
                                                        listConfigPayment={this.state.list_config_payment}
                                                        onChangeAutoBanking={ (actionKey, autoBanking) => this.onChangeAutoBanking(actionKey, autoBanking) }
                                                    />
                                                </Tab.Pane>
                                            ))
                                        }
                                    </Tab.Content>
                                </Col>
                            </Row>
                        </Tab.Container>

                    </div>
                </div>
            )
        } else {
            return (
                <div className="text-danger">
                    Chưa có dữ liệu Auto Banking
                </div>
            )
        }
    }

    onChangeAutoBanking = (actionKey, autoBanking) => {
        let listAutoBanking = this.state.listAutoBanking;
        listAutoBanking[actionKey] = autoBanking;
        this.setState({
            listAutoBanking: listAutoBanking
        })
    }

    addAutoBanking = () => {
        let listAutoBanking = this.state.listAutoBanking;
        let autoBanking = {
            type: 'Thêm mới',
            typeAction: 'create',
            type_bank: 2
        }
        listAutoBanking.push(autoBanking);
        this.setState({
            listAutoBanking: listAutoBanking,
            keyTab: Object.keys(listAutoBanking).length - 1
        })
    }

    submit = () => {
        console.log(this.state.listAutoBanking)
        this.setState({
            isLoading: true,
            btnSubmit: true,
        })
        let dataAuth = {
            username: process.env.REACT_APP_CLIENT_ID,
            password: process.env.REACT_APP_CLIENT_PASSWD,
            token: process.env.REACT_APP_KEY,
        };
        let form = {
            listAutoBanking: this.state.listAutoBanking
        };

        axios.put( process.env.REACT_APP_API_URL + '/api/admin/update-auto-banking', form,
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization' : this.props.token,
                    'dataAgency' : JSON.stringify(dataAuth)
                }
            }
        )
            .then( (ref) => {
                // console.log(ref.data);
                if ( ref.data.error === 0 ) {
                    this.setState({
                        error: false,
                        successForm: true,
                        messageError: ref.data.message,
                        isLoading: false,
                        btnSubmit: false,
                        keyTab: 0
                    })
                    this.loadAutoBanking();
                } else {
                    if ( ref.data.error === 9999 || ref.data.error === 9998 || ref.data.error === 9997 ) {
                        this.props.logOut();
                    } else {
                        this.setState({
                            error: true,
                            messageError: ref.data.message,
                            isLoading: false,
                            btnSubmit: false
                        })
                    }
                }
                // console.log(this.state.perPage);
            })
            .catch( (error) => {
                console.log(error);
                this.setState({
                    error: true,
                    messageError: 'Tạo sản phẩm thất bại',
                    isLoading: false,
                    btnSubmit: false
                })
            })
    }

    render() {
        return (
            <>
                {
                    this.state.isLoading ? (
                        <div className="text-center">
                            <Spinner animation="grow" variant="primary" />
                            <Spinner animation="grow" variant="secondary" />
                            <Spinner animation="grow" variant="success" />
                            <Spinner animation="grow" variant="danger" />
                            <Spinner animation="grow" variant="warning" />
                            <Spinner animation="grow" variant="info" />
                        </div>
                    ) : (
                        <>
                            <Breadcrumb title={"Config System"} page={"Config System"} icon={<RiBankFill className="breadcrumb-icon" />} />
                            <div className="row mb-4" style={{ marginTop: 20 }}>
                                <div className="col-md-12">
                                    <button className="btn btn-primary" onClick={ () => this.addAutoBanking() }>Thêm Auto Banking</button>
                                </div>
                                <div className="col-md-12">
                                    {
                                        this.state.error ? (
                                            <Alert color="danger">
                                                { this.state.messageError }
                                            </Alert>
                                        ) : (
                                            <></>
                                        )
                                    }
                                    {
                                        this.state.successForm ? (
                                            <Alert color="success">
                                                { this.state.messageError }
                                            </Alert>
                                        ) : (
                                            <></>
                                        )
                                    }
                                    {
                                        this.checkNotification()
                                    }
                                </div>
                            </div>
                            <Card>
                                <CardBody>
                                    { this.loadAutoBanking() }
                                </CardBody>
                                {
                                    this.state.listAutoBanking.length ? (
                                        <CardFooter className="text-center">
                                            <button className="btn btn-primary"
                                                    onClick={ () => this.submit() }
                                                    disabled={ this.state.btnSubmit }
                                            >
                                                Lưu thiết lập
                                            </button>
                                        </CardFooter>
                                    ) : (
                                        <></>
                                    )
                                }
                            </Card>
                        </>
                    )
                }
            </>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        token: state.login.token,
        isNotification: state.adminMain.isNotification,
        textNotification: state.adminMain.textNotification,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        logOut: () => {
            dispatch(({ type : 'logOut', page: 'AdminAutoBanking' }))
        },
        notification: (item) => {
            dispatch(({ type : 'notification', item }))
        },
        updateSystem: (item) => {
            dispatch(({type: 'updateSystem', item}))
        },
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(AutoBanking);